<template>
	<div>
		<div class="popBoxBg ">
			
		</div>
		<div class="keyboard">
			<div class="input">{{keyNumber}}
			
				<div class="tips" v-if="showMaxNum">
					最大输入值10000000（1千万）
				</div>
			</div>
			<ul>
				<li class="fcc" v-for="item in 9" @click="num(item)">{{item}}</li>
				
				
				
				
				<li class="fcc" v-if="isZero">0</li>
				<li class="fcc" v-else @click="num('0')">0</li>
				<li class="fcc clear" v-if="isZero">清空</li>
				<li class="fcc clear" v-else @click="clear">清空</li>
				<li class="fcc tuige" v-if="isZero"></li>
				<li class="fcc tuige" v-else @click="tuige"></li>
				<li class="fcc" v-if="isZero">00</li>
				<li class="fcc" v-else @click="num('00')">00</li>
				<li class="fcc" v-if="isZero">000</li>
				<li class="fcc" v-else @click="num('000')">000</li>
				
				
				
				
				
				
				
				
				
				<li class="fcc enter" @click="enter">
					<img src="../../assets/icon/icon-ok.png" >
					<span>确定</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-number',
		props: {
			msg: String
		},
		data() {
			return {
				isZero:true,
				keyNumber:0,
				showMaxNum:false
			}
		},
	
		
		mounted() {
			
		},
		methods: {
			num(i){
				var that=this
				if(Number(that.keyNumber)){
					//不为0的时候
					if(Number(that.keyNumber)<10000000){
						that.keyNumber=Number("" + Number(that.keyNumber) + i)
						if(that.keyNumber>=10000000){
							that.keyNumber=10000000
							that.showMaxNum=true
							console.log("最高可充值9999999")
							that.showMaxNum=true
						}else{
							that.showMaxNum=false
						}
						
					}else{
						that.keyNumber=10000000
						that.showMaxNum=true
						console.log("最高可充值9999999")
					}
					
					
				}else{
					that.showMaxNum=false
					that.keyNumber=i
				}
			
			},
			clear(){
				this.keyNumber=0
			},
			tuige(){
				if (Number(this.keyNumber)<10) {
					this.keyNumber=0
				} else{
					var str=""+this.keyNumber
					str=str.slice(0,str.length-1)
					this.keyNumber=Number(str)
				}
				this.showMaxNum=false
			},
			enter(){
				this.$emit("keyInputNumber",this.keyNumber)
			}
		},
		watch: {
			keyNumber(newValue, oldValue) {
				if (Number(newValue)>0) {
					this.isZero=false
				} else{
					this.isZero=true
				}
				console.log(newValue, oldValue)
			}
		},
		beforeDestroy() {
			
		}
		
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
	.keyboard{
		width: 901px;
		
		background-color: #fff;
		position: absolute;
		left: 50%;
		margin-left: -450px;
		bottom: 120px;
		border-radius: 15px;
		z-index: 110;
		padding-top: 48px;
		.input{
			margin-right: 44px;
			height: 95px;
			background: #EFEFEF;
			border-radius: 10px;
			margin-left: 40px;
			margin-bottom: 33px;
			font-size: 30px;
			line-height: 95px;
			padding-left: 30px;
			padding-right: 30px;
			color: #000;font-weight: bold;
			position: relative;
			.tips{
				position: absolute;
				right: 30px;
				top: 0;
				color: red
			}
		}
		ul{
			display: flex;
			flex-wrap: wrap;
			
			padding-left: 40px;
		}
		li{
			width: 247px;
			height: 95px;
			background: #fff;
			border: 1px solid #DADADA;
			border-radius: 10px;
			font-size: 30px;
			color: #000;
			margin-right: 35px;
			margin-bottom: 33px;
			cursor: pointer;
			&:active{
				background: #00A2FF;
				color: #fff;
			}
		}
		
		.tuige{
			background: url(../../assets/icon/icon-tuige.png) center no-repeat;
			&:active{
				background: url(../../assets/icon/icon-tuige2.png) center no-repeat #00A2FF;
				color: #fff;
			}
		}
		.enter{
			background: #00A2FF;
			color: #fff;
			img{
				margin-right: 14px;
			}
		}
	}
</style>
